/**
 * Rendre les cartes produits entièrement cliquables
 * sauf le bouton d'ajout au projet
 */
(function() {
  'use strict';
  
  function initClickableCards() {
    const cards = document.querySelectorAll('.card--clickable');
    
    cards.forEach(card => {
      // Récupérer l'URL du produit
      const productUrl = card.dataset.productUrl;
      
      if (!productUrl) return;
      
      // Ajouter le gestionnaire de clic sur la carte
      card.addEventListener('click', function(e) {
        // Si on clique sur le bouton ou ses enfants, ne pas naviguer
        if (e.target.closest('.add-to-project-btn') || 
            e.target.closest('.add-to-project-wrapper')) {
          return;
        }
        
        // Si on clique sur un lien existant (comme le titre), ne pas naviguer
        if (e.target.closest('a') && !e.target.closest('.card__heading a')) {
          return;
        }
        
        // Naviguer vers la page produit
        window.location.href = productUrl;
      });
      
      // Ajouter le curseur pointer sur la carte
      card.style.cursor = 'pointer';
    });
  }
  
  // Initialiser au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClickableCards);
  } else {
    initClickableCards();
  }
  
  // Observer les changements du DOM pour les cartes chargées dynamiquement
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        setTimeout(initClickableCards, 100);
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();